// extracted by mini-css-extract-plugin
export default {"fastinfo":"ReportExamDetail_fastinfo__7UzGy"};